import React from 'react'

import Translator from 'bazinga-translator'
import { Icon } from 'components/IconLink/Icon'
import { IconKey } from 'components/IconLink/iconMap'
import Money from 'components/Money'
import { GameWithUserInformation } from 'containers/GamesBlock/types'

import { Info, InfoBox, InfoRow, Label, ProducerIconBox, Value } from './styles'

interface Props {
  game: GameWithUserInformation
}

export function GameDialogInfo({ game }: Props) {
  const { producer, minBet, maxBet, reels, maxWin } = game

  return (
    <InfoBox>
      <InfoRow>
        <Info>
          <Label>{Translator.trans('producer', {}, 'games')}:</Label>
          <Value>
            <ProducerIconBox>
              <Icon icon={producer as IconKey} />
            </ProducerIconBox>

            <span>{Translator.trans(producer, {}, 'games')}</span>
          </Value>
        </Info>
        <Info>
          <Label>{Translator.trans('betMasks', {}, 'games')}:</Label>
          <Value>
            <Money money={minBet} />
            {' - '}
            <Money money={maxBet} />
          </Value>
        </Info>
      </InfoRow>

      <InfoRow>
        <Info>
          <Label>{Translator.trans('reels', {}, 'games')}:</Label>
          <Value>{reels ?? '-'}</Value>
        </Info>
        <Info>
          <Label>{Translator.trans('maxWin', {}, 'games')}:</Label>
          <Value>
            <Money money={maxWin} />
          </Value>
        </Info>
      </InfoRow>
    </InfoBox>
  )
}
